<template>
  <div class="iDalgo-Button" :class="{ 'iDalgo-Button-Bordered': border, 'iDalgo-Button-Disabled': disabled }">
    <el-button @click="handleClick" type="danger" :loading="loading" :disabled="disabled"><slot></slot></el-button>
  </div>
</template>

<script>
export default {
  name: 'iDalgo-Button',
  props: {
    border: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  data () {
    return {}
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Button {
  display: inline-flex;
  .el-button {
    font-family: 'robotobold';
    background: $gradient1;
    border: none;
  }
}

.iDalgo-Button-Bordered {
  border: 1px $color2 dashed;
  padding: 4px;
  border-radius: 3px;
}

.iDalgo-Button-Disabled {
  .el-button {
    background: $gradient2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Button.vue